
import Vue from "vue";
export default Vue.extend({
	props: {
		src: {
			type: String,
			required: true
		},
		imageName: {
			type: String,
			required: true
		}
	},
	computed: {
		style():any {
			return {
				backgroundImage: `url(${this.src})`
			};
		}
	},
	methods: {
		download() {
			let a = document.createElement("a");
			a.href = this.src;
			a.download = this.imageName;
			a.target = "_blank";
			a.style.display = "none";
			document.body.append(a);
			a.click();
			a.remove();
		},
		close(e:Event) {
			e.stopPropagation();
			this.$emit("close");
		}
	}
});
